import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}gift/all?page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 201) {
            return {
                status: 200,
                gifts: response.data.gifts,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(config.apiUrl + 'gift/get-by-id?id=' + id,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                gift: response.data.gift
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}

//create a function to send the name and image to axios post to save the gift
const Add = async (name, image) => {
    try {
        const data = new FormData();
        data.append("name", name);
        data.append("image", image);

        console.log("Image in service : " + image);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'gift/add', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("re",response);
        if (response.status === 201) {
            console.log("Gift added successfully");
            return {
                status: 200,
                message: response.data.message,
                gift: response.data.gift
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message

        };
    }
}

const Update = async (id, name, image, status) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("name", name);
        data.append("image", image);
        data.append("status", status);

        console.log("Image in service : " + image);

        console.log("Data in service : " + data);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'gift/update', data, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        console.log(response.data);
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                gift: response.data.gift
            };
        }
    } catch (error) {
        return {
            status: error.response.status,
            message: error.response.data.message
        };
    }
}

export { Add, Update, GetById, GetAll };
